export const PARAGRAPH_DEFAULTS = {
  padding: '4px 4px 4px 4px', // top right bottom left
  paddingRoot: '4px 30px 4px 30px', // top right bottom left
  margin: '0px 0px 0px 0px', // top right bottom left
  letterSpacing: 'normal',
};
